import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./modules/auth";
import users from "./modules/users";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface RootState {}

export default createStore<RootState>({
  modules: { auth, users },
  plugins: [
    createPersistedState({
      key: "academy-users-crm",
      paths: ["auth"],
    }),
  ],
});
